//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalPropertiesWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Properties' stat={count} />;
};

export default TotalPropertiesWidget;
